import styled from "styled-components";

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

const Col = styled.div`
  grid-column: ${(props) => props.area};
`;
export { Row, Col };
